<template>
  <div>
    <div v-show="!waiverAgreed" style="width: 80%; margin-left: 10%;">
      <a :href="'https://app.mpev.au/members/docs/waiver.pdf'" download="download">Download Waiver</a>
      <v-card>
        <v-card-title>
          <span class="headline">To attend {{trial.trialName}} you must agree to the following waiver.</span>
        </v-card-title>
        <v-card-text>
          <div>
            <B>Please note the requirement for underage participants to bring both pages of the waiver to the event,
              signed by a parent or guardian.<br>
            Also, if you are registering your dog to run with a different handler, that handler needs to bring the
            signed waiver to the event.</B>
          </div>
          <div>
            <pdf v-if="show" ref="pdf" style="border: 1px solid red" :src="src" :page="1" @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
            <pdf v-if="show" ref="pdf" style="border: 1px solid red" :src="src" :page="2" @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
          </div>
        </v-card-text>
        <v-card-actions>
          <a :href="'https://app.mpev.au/members/docs/waiver.pdf'" download="download">Download Waiver</a>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="agree">I agree to the waiver above</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  <v-form v-show="waiverAgreed">
    <v-card>
      <v-card-title>
        <span class="headline">Register for trial {{trial.trialName}}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="2" md="1">
              <v-text-field v-model="owner.mNbr" label="Member #" disabled></v-text-field>
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field v-model="owner.fullName" label="Name" disabled></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="2" md="1">
              <v-text-field v-model="handler.mNbr" label="Handler #" v-on:change="chgHandler"></v-text-field>
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field v-model="handler.fullName" label="Name" disabled></v-text-field>
            </v-col>
          </v-row>
          <v-btn
              v-if="handler.mNbr != owner.mNbr && handler.mNbr.length==5"
              class="ma-2"
              color="orange"
              @click="reset"
          >
            You have specified that another member will handle your dog. If that is not your intent, click here.
          </v-btn>
          <v-row>
            <v-col cols="12" sm="12">
              <v-radio-group v-model="selectedDog">
                <v-radio
                    v-for="n in owner.dogs.length"
                    :key="n"
                    :label="owner.dogs[n-1].kNbr + ' ' + owner.dogs[n-1].callName"
                    :value="owner.dogs[n-1]"
                >
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <confirm ref="confirm"></confirm>
        <VerifyDetails ref="verdtl" :dogowner="owner" :dog="selectedDog" :doghandler="handler" v-show="vdtl"></VerifyDetails>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="reset">Reset</v-btn>
        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
        <v-btn color="blue darken-1" text :disabled="selectedDog==null" @click="save">Register</v-btn>
      </v-card-actions>

    </v-card>
  </v-form>
  </div>
</template>

<script>
import confirm from '@/components/Confirm.vue'
import VerifyDetails from '@/components/VerifyDetails.vue'
import pdf from 'vue-pdf'

export default {
  components: {
    confirm,
    pdf,
    VerifyDetails
  },
  name: "trialreg",
  watch: {
    trial() {
      this.src=this.pdfList[1]
    },
  },
  mounted: function () {
    if (this.$usrStore.token == null) {
      if (localStorage.getItem('token') !== 'undefined') {
        if (localStorage.getItem('token').length > 4) {
          this.$initFromToken(localStorage.getItem('token'))
        }
      }
    }
    this.loadUser()
  },
  data: () => ({
    owner: {'dogs':[]},
    handler: {},
    selectedDog: null,
    vdtl: false,
    waiverAgreed: false,
    agreed: null,
    show: true,
    pdfList: ['','https://app.mpev.au/members/docs/waiver.pdf'],
    src: ''
  }),
  props: {
    trial: {
      type: Object,
      default: null
    },
  },
  methods: {
    agree: function () {
      this.waiverAgreed = true
      this.agreed = new Date()
    },
    chgHandler: function () {
      if(this.handler.mNbr.length == 5) {
        this.loadHandler(this.handler.mNbr)
      }
    },
    close: function () {
      alert('Exit without completing registration')
      this.$emit('endTrialReg', null)
    },
    reset: function () {
      this.selectedDog = null
      this.loadHandler(this.owner.mNbr)
    },
    save: async function () {
      if(this.owner.mNbr !== this.handler.mNbr) {
        if (!(await this.$refs.confirm.open('Save with other handler', 'Are you sure?', {color: 'red'}))) {
          this.reset()
          return
        }
      }
      if (!(await this.$refs.verdtl.open('Please verify', 'Is the information below accurate?', {color: 'primary'}))) {
        this.reset()
        alert("To correct the information about you or your dog, please select \"Member Detail\" above and correct it there.\n\nIf the handler information is incorrect, you probably entered the wrong member number for the handler.\n\nCorrect the information, then try again")
        return
      }

      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true
      try {
        const resp = await this.$http.post(this.$remote + '/api.trial/r', {
          token: theToken,
          p_owner: this.owner.mNbr,
          p_runby: this.handler.mNbr,
          p_dog: this.selectedDog.kNbr,
          p_trial: this.trial.id
        })
        const status = resp.data.validation.status
        if (status == 'ok') {
          alert("Your dog has been added to the registration list.")
          let dest = this.trial.premium
            window.location.href=dest
        }
        if (status == 'prov') {
          alert("The team has been added to the registration list. The handler and /or the dog was already on that list. If the trial doesn't fill, you may be given a spot as FEO")
        }
        if (status == 'rej') {
          alert("The registration was rejected. " + resp.data.validation.msgs.toString())
        }
        if (status == 'unpaid') {
          let msg = "The registration could not be accepted.\n" + resp.data.validation.msgs.toString()
          let pmtURL = `${this.$express}/w3/d/${this.$UUIDv4()}/${this.owner.mNbr}/${this.selectedDog.kNbr}`
          console.log(pmtURL)
          if (window.confirm(`${msg}\nPress OK to pay the fee now`)) {
            window.open(pmtURL);
            if(window.confirm('Click OK after you have paid to retry registering')){
              this.save()
            }
          }
          return
        }
      } catch (e) {
        alert(e)
      }

      this.$emit('endTrialReg', null)
    },
    loadUser: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true
      this.$http.post(this.$remote + '/api/mbr', {
        token: theToken,
        mbrId: this.$usrStore.id
      })
          .then(response => {
            this.owner = response.data.mbr
            //this.handler = response.data.mbr
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loadHandler(this.owner.mNbr)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                  window.location.assign('/members')
                } else {
                  alert(err)
                }
              }
          )
    },
    loadHandler: function (mNbr) {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/mbr2', {
        token: theToken,
        mNbr: mNbr
      })
          .then(response => {
            this.handler = response.data.mbr
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                  window.location.assign('/members')
                } else {
                  alert(err)
                }
              }
          )
    }
  },
  computed: {
    isValid () {
      return (this.selectedDog !== {})
    },
  }
}
</script>
